<h2
    class="ignore-kibon-legacy tw:mb-4 tw:mt-4 tw:text-[2rem] tw:font-semibold tw:tracking-[0.15rem] tw:md"
>
    <ng-content></ng-content>
</h2>
